export function cn(...parts: Array<string | false | 0 | 0n | null | undefined>): string {
  return parts.filter((p): p is string => typeof p === "string" && p.length > 0).join(" ");
}

/** Every interactive surface in the kit shares these habits.
 *  Focus (Components · Button / Primary · focused): a 2px cream ring, 3px
 *  offset, keyboard only. Fields are the one exception — their amber border
 *  and caret mark where typing goes. */
export const FOCUS =
  "outline-none focus-visible:outline-2 focus-visible:outline-offset-[3px] focus-visible:outline-focus";
/** Tap feedback (brand book §07): 120ms, scale 0.97. Colour changes on hover
 *  ride the same 120ms so rings and fills never lag the press. */
export const PRESS = "transition-all duration-[120ms] ease-out active:scale-[0.97]";
/** 44px minimum touch target (WCAG 2.5.8 / iOS HIG). */
export const TAP = "min-h-[44px]";
/** Disabled: 35% opacity, no hover, no press (Components · Button). */
export const DISABLED = "pointer-events-none opacity-35";
